/**
 * The first word of a full name — "Noa" from "Noa Park" — for the places a
 * screen talks about a child the way a parent would: "Cancel Noa's lesson".
 */
export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}
